import axios from './api';

import { TEMPLATES_PER_PAGE } from './utilities/constants';
import { transformSurveyTemplate, transformSurveyTemplates } from './utilities/helpers';

/**
 * read survey template
 * @param {Object} options
 * @param {string} [options.instantSurveyType]
 * @param {number} [options.limit]
 * @param {number} [options.offset]
 * @param {string} [options.ordering]
 * @param {string} [options.search]
 * @param {AbortSignal} options.signal
 * @return {Promise}
 */

export const readSurveyTemplates = async ({
  instantSurveyType: instant_survey_type_id,
  limit = TEMPLATES_PER_PAGE,
  offset,
  ordering,
  search,
  signal,
}) => {
  return axios({
    method: 'get',
    params: {
      condensed: true,
      instant_survey_type_id,
      limit,
      offset,
      ordering,
      search,
    },
    signal,
    url: '/instantsurvey/surveytemplate',
  }).then(({ data }) => transformSurveyTemplates(data));
};

/**
 * read survey template detail
 * @param {Object} options
 * @param {number} options.id
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const readSurveyTemplate = async ({ id, signal }) => {
  return axios({
    method: 'get',
    signal,
    url: `/instantsurvey/surveytemplate/${id}`,
  }).then(({ data }) => transformSurveyTemplate(data));
};
